import React from 'react';
import { BaseAlert } from './BaseAlert';
import { NotificationAlertState } from './useNotificationAlert';

interface NotificationAlertProps {
    notification?: NotificationAlertState;
    onCancel: () => void;
}

export const NotificationAlert: React.FC<NotificationAlertProps> = ({ notification, onCancel }) => (
    <BaseAlert
        open={!!notification}
        onCancel={onCancel}
        variant={notification?.variant ?? 'success'}
        title={notification?.title ?? ''}
        content={notification?.content ?? ''}
        buttonLabel={notification?.cancelButtonLabel}
    />
);
